"use client";

import { CustomButton } from "@/shared/ui/molecules";
import { DirectionIcon, Typography } from "@/shared/ui/atoms";
import { useState, useEffect } from "react";
import TreatmentFilterModal from "@/widgets/search-result/ui/templates/Modal/TreatmentFilterModal";
import { FilterValue } from "@/shared/types/type/search";
import useSearchUIStore from "@/features/search-result/model/ui/store";
import { useTranslations } from "next-intl";
import { useSearchParams } from "next/navigation";
interface TreatmentFilterButtonProps {
  treatmentList: FilterValue[];
  hideTreatmentAllOption?: boolean;
  defaultTreatmentId?: number;
}
const TreatmentFilterButton = ({
  treatmentList,
  hideTreatmentAllOption,
  defaultTreatmentId
}: TreatmentFilterButtonProps) => {
  const t = useTranslations();
  const pathParams = useSearchParams();
  const treatmentIds = pathParams?.get("treatment");
  const defaultTreatmentText = t("commonSearch.filter.treatment");
  const {
    selectedTreatmentDisplayName: displayName,
    setSelectedTreatmentDisplayName
  } = useSearchUIStore();
  const [openTreatmentModal, setOpenTreatmentModal] = useState(false);
  useEffect(() => {
    try {
      const effectiveTreatmentId = treatmentIds ?? defaultTreatmentId?.toString();
      if (!effectiveTreatmentId) {
        setSelectedTreatmentDisplayName(defaultTreatmentText);
        return;
      }
      const treatment = treatmentList.find(item => item.id.toString() === effectiveTreatmentId);
      setSelectedTreatmentDisplayName(treatment?.name || defaultTreatmentText);
    } catch {
      setSelectedTreatmentDisplayName(defaultTreatmentText);
    }
  }, [defaultTreatmentId, treatmentList, setSelectedTreatmentDisplayName, openTreatmentModal, defaultTreatmentText, treatmentIds]);
  const isSelected = displayName && displayName !== defaultTreatmentText;
  const buttonClassName = isSelected ? "rounded-full border border-[#C9B8FF] bg-[#F6F2FF] flex items-center justify-between py-[7px] px-[14px] gap-1" : "rounded-full border border-[#E1E2E4] bg-white flex items-center justify-between py-[7px] px-[14px] gap-1";
  return <>
      <CustomButton className={buttonClassName} onClick={() => setOpenTreatmentModal(true)}>
        <Typography size={15} lineHeight={22} className={`font-semibold ${isSelected ? "text-[#6B00D7]" : "text-[#5A5C63]"}`}>
          {displayName || defaultTreatmentText}
        </Typography>
        <DirectionIcon size={14} className={isSelected ? "text-[#6B00D7]" : "text-[#A5A5A5]"} />
      </CustomButton>
      <TreatmentFilterModal key={openTreatmentModal ? `open-${treatmentIds ?? defaultTreatmentId ?? ""}` : "closed"} open={openTreatmentModal} onClose={() => setOpenTreatmentModal(false)} treatmentList={treatmentList} hideTreatmentAllOption={hideTreatmentAllOption} defaultTreatmentId={defaultTreatmentId} />
    </>;
};
export default TreatmentFilterButton;